"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
var React = require("react");
var styled_components_1 = require("styled-components");
var core_1 = require("../core");
var stripUnit_1 = require("../helper/stripUnit");
var calculateUnit = core_1.memo(function (values, ranges, easing) {
    var val;
    if (ranges.length === 1) {
        // If range has only one item, return it
        val = stripUnit_1.stripUnit(ranges[0]);
    }
    else if (ranges.length === 2) {
        // If range has two items, interpolate between them and return it
        var _a = stripUnit_1.stripUnit(ranges[0]), minValue = _a[0], minUnit = _a[1];
        var _b = stripUnit_1.stripUnit(ranges[1]), maxValue = _b[0], maxUnit = _b[1];
        var value = core_1.interpolate(values, [minValue, maxValue], easing);
        val = [value, minUnit || maxUnit];
    }
    else if (ranges.length > 2) {
        // If range has more entries, loop through them and interpolate between two values
        var step = 1 / (ranges.length - 1);
        for (var i = 0; i < ranges.length; i += 1) {
            if (values < i * step) {
                var _c = stripUnit_1.stripUnit(ranges[i - 1]), minValue = _c[0], minUnit = _c[1];
                var _d = stripUnit_1.stripUnit(ranges[i]), maxValue = _d[0], maxUnit = _d[1];
                var percent = ((values - (i - 1) * step) / (i * step - (i - 1) * step)) * 1;
                var value = core_1.interpolate(percent, [minValue, maxValue], easing);
                val = [value, minUnit || maxUnit];
                break;
            }
            else if (values === i * step) {
                val = stripUnit_1.stripUnit(ranges[i]);
                break;
            }
        }
    }
    return val;
});
exports.unit = function (value, range, easing, transform) { return function (props) {
    var theme = props.theme;
    var values = core_1.getValue(value, theme);
    var ranges = core_1.getRange(range, theme);
    var _a = calculateUnit(values, ranges, easing), val = _a[0], unitString = _a[1];
    return transform ? transform(val, unitString) : "" + val + unitString;
}; };
exports.useUnit = function (value, range, easing, transform) {
    var theme = React.useContext(styled_components_1.ThemeContext);
    return exports.unit(value, range, easing, transform)({ theme: theme });
};
//# sourceMappingURL=unit.js.map